import axios from 'api/axios'
import { BroadcastInsights, BroadcastWithClientData } from 'types'

export interface GetBroadcastBody {
	id: string
}

export interface GetBroadcastResponse {
	broadcast: BroadcastWithClientData
	insights: BroadcastInsights
}

const getBroadcast = async (
	body: GetBroadcastBody
): Promise<GetBroadcastResponse> => {
	const { data } = await axios.get<GetBroadcastResponse>(
		`v1/broadcast/management/${body.id}`
	)

	return data
}

export default getBroadcast
